import React from 'react';
import { IconProps } from '.';

const SvgStoreFillRounded = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M15 13.078a4.65 4.65 0 0 0 3 1.089c.634 0 1.275-.107 1.875-.34v5.45c0 1.228-1.007 2.223-2.25 2.223H6.375c-1.243 0-2.25-.995-2.25-2.222v-5.451c.6.233 1.241.34 1.875.34 1.15 0 2.192-.412 3-1.089a4.649 4.649 0 0 0 3 1.089c1.15 0 2.191-.412 3-1.089ZM17.376 2.5c.97 0 1.83.612 2.124 1.525.593 1.837 1.5 4.763 1.5 5.444 0 2.02-1.343 3.031-3 3.031s-3-1.357-3-3.03c0 1.673-1.343 3.03-3 3.03s-3-1.357-3-3.03c0 1.673-1.343 3.03-3 3.03-1.656 0-3-1.01-3-3.03 0-.682.907-3.608 1.5-5.445A2.22 2.22 0 0 1 6.624 2.5h10.752Z'
      />
    </svg>
  );
};

export default SvgStoreFillRounded;
